import { render, staticRenderFns } from "./zjsList.vue?vue&type=template&id=2dfd63ea&scoped=true"
import script from "./zjsList.vue?vue&type=script&lang=js"
export * from "./zjsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd63ea",
  null
  
)

export default component.exports